import { Components } from 'formiojs-llq';
import editForm from './SelectBoxCustom.form'
import _ from 'lodash';
import { getToken } from 'app/services/TokenStorageService';
const selectboxes = (Components as any).components.selectboxes;

export default class SelectBoxesCustom extends (selectboxes as any) {
    // Schema render form
    static schema(...extend: any[]) {
        return selectboxes.schema({
            type: 'selectboxescustom',
            label: 'Select Boxes Custom',
            key: 'selectBoxesCustom',
            inline: false,
            data: {
                headers: [],
            },
            disableLimit: true
        }, ...extend);
    }
    public static editForm = editForm;

    // Form Builder information
    static get builderInfo() {
        return {
            title: 'Select Boxes - LLQ',
            group: 'basic',
            icon: 'plus-square',
            weight: 60,
            documentation: '/userguide/form-building/form-components#select-box',
            schema: SelectBoxesCustom.schema()
        };
    }

    constructor(component: any, options: any, data: any) {
        super(component, options, data);
    }

    init() {
        if (this.component.authenticate === true) {
            this.component.data.headers = [
                { key: 'Authorization', value: ('Bearer ' + getToken()) }
            ]
        }
        super.init();
    }

    updateItems(searchInput: any, forceUpdate: any) {
        if (this.component.dataSrc === 'tables') {
            let { url } = this.component.data;
            let method;
            let body;
            if (!this.component.data.method) {
                method = 'GET';
            }
            else {
                method = this.component.data.method;
                if (method.toUpperCase() === 'POST') {
                    body = this.component.data.body;
                }
                else {
                    body = null;
                }
            }

            const options = this.component.authenticate ? {} : { noToken: true };
            let query: string[] = [];
            if (this.component.precondition) {
                this.component.preconditions.forEach((item: any) => {
                    let expression: string[] = [];
                    item.componentData.forEach((data: any) => {
                        console.log(this);
                        let value = this.getValueByType(data.value)
                        value && expression.push(value);
                    })
                    expression.length && query.push(item.column + '=:' + expression.join());
                })
            }

            let newUrl = '';
            if (query.length) {
                newUrl = url + "&" + (query.join('&'));
            } else {
                newUrl = url;
            }

            this.loadItems(newUrl, searchInput, this.requestHeaders, options, method, body);
        }
        super.updateItems(searchInput, forceUpdate);
    }

    render() {
        return super.render();
    }

    attach(element: any) {
        let precondition = this.component.precondition;
        let preconditions = this.component.preconditions;
        this.onAny((event: any, ...args: any) => {
            if (event === 'formio.componentChange') {
                console.log('Vua co component update');
                let componentChanged = args[0].component.key;
                let found = false; // Biến flag

                preconditions && preconditions.forEach((item: any) => {
                    if (found) {
                        return;
                    }

                    item.componentData.forEach((data: any) => {
                        if (data.value.key === componentChanged) {
                            this.updateItems(null, true);
                            found = true;
                            return;
                        }
                    });
                });
            }
        });
        return super.attach(element)
    }

    getValueByType(component: any) {
        if (component.type === 'selectboxes' || component.type === 'selectboxescustom') {
            let data = this._data[component.key];
            let result: string[] = [];
            for (let key in data) {
                if (data[key] === true) {
                    result.push(key);
                }
            }
            return result.join();
        }
        return this._data[component.key]
    }
}